import React, { Suspense } from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";

import PageLoading from "shared/components/PageLoading";

import useScrollToTopOnNavigation from "routers/shared/hooks/useScrollToTopOnNavigation";
import { ROUTES, AUTHED_ROUTE_LIST } from "routers/shared/util/consts";

const Splash = React.lazy(() => import(/* webpackChunkName: "spa_splash" */ "apps/splash"));
const AccountReactivate = React.lazy(() => import(/* webpackChunkName: "spa_reactivate_login" */ "apps/login"));
const Signup = React.lazy(() => import(/* webpackChunkName: "spa_signup" */ "apps/signup"));
const Logout = React.lazy(() => import(/* webpackChunkName: "spa_logout" */ "apps/logout"));
const NotFound = React.lazy(() => import(/* webpackChunkName: "spa_404" */ "./NotFound"));
const Legal = React.lazy(() => import(/* webpackChunkName: "spa_loggedout_legal" */ "apps/legal"));
const LegalPurchaseTerms = React.lazy(() => import(/* webpackChunkName: "spa_loggedout_legal_purchase_terms" */ "apps/legal_purchase_terms"));
const About = React.lazy(() => import(/* webpackChunkName: "spa_about" */ "apps/about"));
const Press = React.lazy(() => import(/* webpackChunkName: "spa_press" */ "apps/press"));
const Careers = React.lazy(() => import(/* webpackChunkName: "spa_careers" */ "apps/careers"));

const UnauthedRoutes = ({ location }) => {
	// Scroll to the top on each page nav.
	useScrollToTopOnNavigation(location);

	return (
		<Suspense fallback={<PageLoading />}>
			<Switch>
				<Route
					exact
					path={ROUTES.Splash}
					component={Splash}
				/>
				<Route
					exact
					path={ROUTES.AccountReactivate}
					component={AccountReactivate}
				/>
				<Route
					path={ROUTES.Signup}
					component={Signup}
				/>
				<Route
					exact
					path={ROUTES.Logout}
					component={Logout}
				/>
				<Route
					exact
					path={ROUTES.Legal}
					component={Legal}
				/>
				<Route
					exact
					path={ROUTES.LegalPurchaseTerms}
					component={LegalPurchaseTerms}
				/>
				<Route
					exact
					path={ROUTES.About}
					component={About}
				/>
				<Route
					exact
					path={ROUTES.Press}
					component={Press}
				/>
				<Route
					exact
					path={ROUTES.Careers}
					component={Careers}
				/>

				{/* Legacy paths */}
				<Redirect exact from={ROUTES.LostPassword} to={`${ROUTES.SplashLogin[0]}?step=reset_password`} />

				{/* Redirect all authed routes to the /login page */}
				{AUTHED_ROUTE_LIST.map((authedRoute) => (
					<Route
						key={authedRoute}
						exact
						path={authedRoute}
						render={(params) => (
							<Redirect
								to={`${ROUTES.SplashLogin[0]}?redirect=${params.location.pathname}`}
							/>
						)}
					/>
				))}

				<Route component={NotFound} />
			</Switch>
		</Suspense>
	);
};

UnauthedRoutes.propTypes = {
	location: PropTypes.object.isRequired,
};

export default UnauthedRoutes;



// WEBPACK FOOTER //
// ./src/routers/Desktop/UnauthedRoutes.jsx